module.exports = __webpack_public_path__ + "static/media/meriamwebster.63a141c6.png";